import React, { memo, useState } from 'react';

import { useParams } from 'react-router-dom';

import ActivityLogs from '@components/activity-logs';
import DetailsContent from '@components/details/details-content';
import Info from '@components/group/info';
import Notifications from '@components/group/notifications';

import { Tab, Tabs } from '@shared/tabs';
import { isNewGroupLayout } from '@constants/config';

const Details = () => {
  const { groupType, id } = useParams();
  const [tab, setTab] = useState('details');

  return (
    <DetailsContent>
      <Tabs
        onChange={setTab}
        tabItemWidth="110px"
        tabTemplateStyle={{ height: '100%'}}
        value={tab}
      >
        <Tab label="DETAILS" value="details">
          {tab === 'details' && <Info activeTab="details" />}
        </Tab>
        {id && (
          <Tab label="LIST" value="list">
            {tab === 'list' && <Info activeTab="list" />}
          </Tab>
        )}
        {id && id !== 'new' && (
          <Tab label="METRICS" value="metrics">
            {tab === 'metrics' && <Info activeTab="metrics" />}
          </Tab>
        )}
        {id && id !== 'new' && groupType === 'boundary' && isNewGroupLayout() && (
          <Tab label="NOTIFICATIONS" value="notifications">
            {tab === 'notifications' && <Notifications />}
          </Tab>
        )}
        {id && id !== 'new' && (
          <Tab label="ACTIVITY LOG" value="activity-log">
            {tab === 'activity-log' && (
              <ActivityLogs
                embedded
                params={{ app: 'group', model: 'group', dataId: id }}
              />
            )}
          </Tab>
        )}
      </Tabs>
    </DetailsContent>
  );
};

export default memo(Details);
